"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseError = exports.del = exports.put = exports.read = exports.post = exports.patch = void 0;
// import base from './base';
var base_1 = __importDefault(require("./base"));
var request_1 = __importDefault(require("./request"));
var exception_1 = __importDefault(require("./exception"));
var request = base_1.default;
exports.patch = request_1.default.patch;
exports.post = request_1.default.post;
exports.read = request_1.default.read;
exports.put = request_1.default.put;
exports.del = request_1.default.del;
exports.ResponseError = exception_1.default;
exports.default = request;
